import React, { useEffect } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import useProducts from '../hooks/useProducts';
import Banner from './Banner';
import ProductCard from './ProductCard';
import SkeletonCard from './SkeletonCard';
import '../styles/main.css';

export default function ProductList() {
  const { businessName, salePointName } = useOutletContext();
  const { products, loading, notFound } = useProducts(businessName, salePointName);
  const navigate = useNavigate();

  // Redirect to /not-found if sale point is not found
  useEffect(() => {
    if (notFound) {
      navigate('/not-found', { replace: true });
    }
  }, [notFound, navigate]);

  return (
    <div className="product-list">
      <div className="page-center">
        {/* <Banner salePointName={salePointName} /> */}
        <Banner businessName={businessName} salePointName={salePointName} />

      </div>

      <div className="product-grid">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
        ) : (
          products.map((product, index) => (
            <ProductCard key={product.id || index} product={product} index={index} />
          ))
        )}
      </div>
    </div>
  );
}
